import wrapper from 'wrapper';
import events from './events-emitter';

class AnimationToggle {
    constructor() {
        this.toggle = wrapper.select('.animation-toggle');
        this.toggleLabel = wrapper.select('.toggle__label');
        this.getAnimatedElements();
        this.toggle.addEventListener('change', e => {
            events.emit('animation-toggled', e.target.checked);
        });
        events.on('animation-toggled', (checked) => this.updateAnimationStatus(checked));

        // disable animation by default is prefers-reduced-motion enabled
        // otherwise set to enabled, prevents mismatch on reload if user checked and refreshed
        const checkbox = this.toggle.querySelector('input');
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)').matches;
        checkbox.checked = !prefersReducedMotion;
        this.toggleLabel.textContent = checkbox.checked ? __('animation_toggle_enabled') : __('animation_toggle_disabled');

        events.emit('animation-toggled', checkbox.checked);
    }

    updateAnimationStatus(checked) {
        if (checked) {
            this.toggleLabel.textContent = __('animation_toggle_enabled');
            this.animatedEls.forEach((el) => el.classList.add('animated'));

            wrapper.trackUserAction('animations enabled', checked);
        }
        else {
            this.toggleLabel.textContent = __('animation_toggle_disabled');
            this.animatedEls.forEach((el) => el.classList.remove('animated'));

            wrapper.trackUserAction('animations enabled', 'false');
        }
        this.updateAnimatedElements(checked);
    }

    getAnimatedElements() {
        this.animatedEls = wrapper.selectAll('.animated');
        this.animatedImageEls = wrapper.selectAll('.animated-img');
        this.animatedImages = [];
        this.animatedImageEls.forEach((img) => {
            this.animatedImages.push({
                el: img,
                gif: img.src,
                fallback: img.dataset.fallback,
            });
        });

        this.hiddenSteps = wrapper.selectAll('.step.hidden');
        this.stepsToMinifyIfAnimationsDisabled = this.hiddenSteps.filter((el) => el.classList.contains('animated'));
    }

    updateAnimatedElements(animationEnabled) {
        this.animatedImages.forEach((img) => {
            const { el, fallback, gif } = img;
            el.src = animationEnabled ? gif : fallback;
        });
        this.stepsToMinifyIfAnimationsDisabled.forEach((step) => {
            step.classList.remove('skip-step');
            if (!animationEnabled) step.classList.add('skip-step');
        });
    }
}

export default AnimationToggle;
